// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-46343755]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #f1f2f7;padding:15px;margin:0 -15px;margin-bottom:15px}.wrapper .text-wrapper[data-v-46343755]{padding:0 15px}.wrapper .text-wrapper h4[data-v-46343755]{margin:0}.wrapper .text-wrapper span[data-v-46343755]{font-size:12px;color:#95a1b5}", ""]);
// Exports
module.exports = exports;
